import { IBaseService, IPaginationDto } from '@/bundles/App/interfaces';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import HttpTransport from '@/bundles/Http/transport/HttpTransport';

export default class WeeklyChallengeService implements IBaseService<any> {
  errorMapper: ErrorMapper;
  transport: HttpTransport;

  constructor (props: IBaseService<any>) {
    this.errorMapper = props.errorMapper;
    this.transport = props.transport;
  }

  getList(params: IPaginationDto) {
    try {
      return this.transport.get('/weekly-challenge/admin-list', params);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  createChallenge(formData: FormData) {
    try {
      return this.transport.post('/weekly-challenge/create-with-image', formData, { 'content-type': 'multipart/form-data' });
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  updateChallenge(id: number, formData: FormData) {
    try {
      return this.transport.put(`/weekly-challenge/${id}/update-with-image`, formData, {'content-type': 'multipart/form-data'});
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}

